import { Component } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { RateLine } from 'src/app/modules/rates/_types/rate-line';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { firstValueFrom } from 'rxjs';
import { TransactionsLinesService } from 'src/app/modules/transactions/_services/transactions-lines.service';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { TransactionsService } from 'src/app/modules/transactions/_services/transactions.service';
import { TransactionsStatesService } from 'src/app/modules/transactions/_services/transactions-states.service';
import { TransactionsTypesService } from 'src/app/modules/transactions/_services/transactions-types.service';
import { Job } from 'src/app/modules/cases/_types/job';
import { JobsService } from 'src/app/modules/cases/_services/jobs.service';
import { TransactionLine } from 'src/app/modules/transactions/_types/transaction-line';
import { TasksRoutingModule } from 'src/app/modules/tasks/tasks-routing.module';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CapabilitiesService } from 'src/app/modules/common/_services/capabilities.service';
import { Capability } from 'src/app/modules/common/_types/capability';
import { CasesServicesService } from '../../_services/cases-services.service';
import { PaymentMethod } from 'src/app/modules/common/_types/payment-method';
import { PaymentsMethodsService } from 'src/app/modules/common/_services/payments-methods.service';
import { BusinessBankAccount } from 'src/app/modules/business/_types/business-bank-account';
import { BusinessBankAccountsService } from 'src/app/modules/business/_services/business-bank-accounts.service';
import { ContractTransactionSeriesService } from 'src/app/modules/companies/_services/contracts-transactions-series.service';
import { TransactionsSeriesService } from 'src/app/modules/transactions-series/_services/transactions-series.service';
import { CasesService } from '../../_services/cases.service';
import { Case } from '../../_types/case';
import { LoginService } from 'src/app/modules/login/login.service';
import { TransactionType } from 'src/app/modules/transactions/_types/transaction-type';
import { CaseNotificationNumber } from '../../_types/case-notification-number';
import { CasesNotificationsNumbersService } from '../../_services/cases-notifications-numbers.service';
import { CaseStateChangeComponent } from '../case-state-change/case-state-change.component';
import { AffectedsService } from '../../_services/affecteds.service';

@Component({
    selector: 'app-jobs-pending-invoice',
    templateUrl: './jobs-pending-invoice.component.html',
    styleUrls: ['./jobs-pending-invoice.component.scss'],
    standalone: false
})
export class JobsPendingInvoiceComponent {

  public loading: boolean = false;
  public jobs: any;
  public totalJobs: any;
  public jobsNotBillable: any;
  public jobsNotCaseServiceValidated: any;
  public selectedLines: Job[] = [];
  public transaction: any = {};
  public pendingServices: any = [];
  public selectedCaseNotificationNumber?: CaseNotificationNumber;
  public case?: Case;
  public caseNotificationNumbers: CaseNotificationNumber[] = [];

  public invoiceModes: { name: string, id: string }[] = [
    { name: 'Albaranes', id: 'outgoing_delivery' },
    { name: 'Facturas', id: 'invoice' },
  ];
  public filteredInvoiceModes: { name: string, id: string }[] = [];

  public targets: { name: string, id: string }[] = [
    { name: 'Compañía', id: 'Company' },
    { name: 'Asegurado', id: 'Client' },
    { name: 'Implicado', id: 'ThirdParty' }
  ];
  
  public transactionTypeInvoice: TransactionType = new TransactionType();
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public paymentsMethods: Array<PaymentMethod> = new Array<PaymentMethod>();
  public selectedPaymentMethodRequiresBank: boolean = false;
  public billingCompaniesBanksAccounts: Array<BusinessBankAccount> = new Array<BusinessBankAccount>();
  public paymentDuedateDays: number = 0;
  public transactionSeries: any = [];
  public companyRequireClosedError:boolean = false;
  public affecteds: any[] = [];
  public sendToCompany: boolean = false;

  constructor(
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private jobsService: JobsService,
    private messageService: MessageService,
    private casesService: CasesService,
    private transactionsService: TransactionsService,
    private casesServicesService: CasesServicesService,
    private paymentsMethodsService: PaymentsMethodsService,
    private businessBankAccountsService: BusinessBankAccountsService,
    private transactionsTypesService: TransactionsTypesService,
    private contractTransactionSeriesService: ContractTransactionSeriesService,
    private transactionSeriesService:TransactionsSeriesService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private loginService: LoginService,
    private caseNotificationNumbersService: CasesNotificationsNumbersService,
    private affectedsService: AffectedsService
  ) {
  }

  async ngOnInit() {    

    this.transaction.invoiceMode = this.config.data.invoiceMode;
    this.transaction.invoiceDiscount = this.config.data.invoiceDiscount;
    this.transaction.invoiceRetentionPercent = this.config.data.invoiceRetentionPercent;
    this.transaction.invoiceRetentionDays = this.config.data.invoiceRetentionDays;
    this.transaction.paymentMethodId = this.config.data.paymentMethodId; 
    this.transaction.businessId = this.config.data.businessId; 
    
    
    this.transaction.billingCompanyBankAccountId = this.config.data.billingCompanyBankAccountId;                  
    this.transaction.target = "Company";
    this.transaction.date = new Date();    
    this.transaction.paymentDuedate = new Date(this.transaction.date);
    this.transaction.paymentDuedate.setDate(this.transaction.date.getDate() + this.config.data.paymentDuedateDays);        
    
    this.allowWrite = this.loginService.hasPermission("CASES.WRITE");
    this.allowDelete = this.loginService.hasPermission("CASES.DELETE");       

    await this.loadCase();
    await this.loadCaseNotificationNumbers();
    await this.loadData();  
    await this.loadPendingServices();      
    await this.loadPaymentsMethods();
    await this.loadBillingCompaniesBankAccounts();
    await this.onPaymentMethodChange(this.transaction.paymentMethodId);
    await this.targetSelected();
    await this.loadTransactionSeries();
  }

  onCaseNotificationNumberSelected(){
    this.transaction.caseNotificationNumberId = this.selectedCaseNotificationNumber?.id;
  }

  async loadCase(){
    this.case = await firstValueFrom(this.casesService.get(this.config.data.caseId, { include: ['contract', 'contract.integration', 'caseState'] }));
    if(!this.case.contract.allowBillIfNotClosed && !this.case.caseState.isFinal){
      this.companyRequireClosedError = true;
    }
  }

  //el envío a la compañía solo aplica a facturas a compañía de expedientes con integración CASER
  get canSendToCompany(): boolean {
    return this.transaction.target == 'Company'
        && this.transaction.invoiceMode == 'invoice'
        && this.case?.contract?.integration?.code == 'CASER';
  }

  async loadData() {
    
    this.transaction.notes = null;

    let paramsJobs: IParamsCollection = {

    }
    let filtersJobs: any = {      
      isForCompany: new Filter(FilterOperation.equals, "isForCompany", "", true),
      isReview: new Filter(FilterOperation.equals, "isReview", "", true),
      transactionId: new Filter(FilterOperation.equals, "transactionId", "", null, true),
      caseId: new Filter(FilterOperation.equals, "caseId", "", this.config.data.caseId, true),
    };    


    paramsJobs.filter = FilterBuilder.fromObject(filtersJobs).build();
    paramsJobs.include = ['caseService', 'worker', 'case', 'case.caseType', 'case.contract.business', 'case.client', 'rateLine.capability'];

    let response = await firstValueFrom(this.jobsService.all(paramsJobs));

    //solo los marcados como facturables y con la visita validada o que venga de proveedor o que venga de "franquicia".
    this.totalJobs = response.data.filter(m => m.isBillable && (m.caseService?.isValidated || (m.caseServiceId == null)));              

    //los no facturables para mostrarlos en info
    this.jobsNotBillable = response.data.filter(m => !m.isBillable);

    //los de visitas no revisadas para mostrarlos en info
    this.jobsNotCaseServiceValidated = response.data.filter(m => !m.caseService?.isValidated);
    
    this.targetSelected();
      
  }
  async loadCaseNotificationNumbers(){
    let params: IParamsCollection = {};
    let filters:any = {
      caseId: new Filter(FilterOperation.equals, "caseId", "", this.config.data.caseId, true),
    };
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.caseNotificationNumbersService.all(params));
    this.caseNotificationNumbers = response.data;    
    if(this.caseNotificationNumbers.length == 1){
      this.selectedCaseNotificationNumber = this.caseNotificationNumbers[0];
      this.transaction.caseNotificationNumberId = this.selectedCaseNotificationNumber.id;
    }
  }

  async loadPendingServices() {
    //Buscamos servicios con dateEnd null y que no tengan trabajos pendientes de facturar
    let params: IParamsCollection = {};
    let filters:any = {
      dateEnd: new Filter(FilterOperation.equals, "dateEnd", "", null, true),    
      isCancelled: new Filter(FilterOperation.equals, "isCancelled", "", false, true),    
      caseId: new Filter(FilterOperation.equals, "caseId", "", this.config.data.caseId, true),
    };

    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.casesServicesService.all(params));

    this.pendingServices = response.data;    
  }
  

  async save(){

    if (!this.transaction.transactionSerieId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Debe seleccionar una serie de factura.'
      });
      return;
    }
    
    //Comprobar si hay seleccionado invoiceMode
    if(this.transaction.invoiceMode == null || this.transaction.invoiceMode == undefined){
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Debe seleccionar un modo de factura.'
      });
      return;
    }

    if(this.caseNotificationNumbers.length > 0 && !this.transaction.caseNotificationNumberId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Debe seleccionar un servicio.'
      });
      return;
    }

    //Comprobar hay cuenta bancaria seleccionada
    if(this.selectedPaymentMethodRequiresBank && this.transaction.invoiceMode == "invoice" && (this.transaction.billingCompanyBankAccountId == null || this.transaction.invoiceMode == undefined)){
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Debe seleccionar una cuenta bancaria.'
      });
      return;
    }

    //Si hay trabajos seleccionados con chargedByWorker a true, transaction.invoiceRetentionPercent no puede ser mayor que 0
    if(this.transaction.invoiceRetentionPercent > 0 && this.selectedLines.some((job: any) => job.chargedByWorker)){
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No se puede aplicar retención de obra a trabajos cobrados por el trabajador.'
      });
      return;
    }

    if(this.transaction.target == 'ThirdParty' && this.transaction.thirdPartyId == null){
      this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se puede generar factura si no se selecciona al implicado'
        });
        return;
    }

    if(this.selectedLines.length > 0){
                  
      let data:any = {
        transactionSerieId: this.transaction.transactionSerieId != "default"?this.transaction.transactionSerieId:null,
        date: this.transaction.date.toISOString(),
        caseId: this.config.data.caseId,
        invoiceMode: this.transaction.invoiceMode,
        invoiceDiscount: this.transaction.invoiceDiscount,
        invoiceRetentionPercent: this.transaction.invoiceRetentionPercent,
        invoiceRetentionDays: this.transaction.invoiceRetentionDays,        
        caseNotificationNumberId: this.transaction.caseNotificationNumberId,
        notes: this.transaction.notes,   
        target: this.transaction.target,  
        jobsIds: this.selectedLines.filter(item => item !== undefined).map(n => n.id!),        
        businessId: this.transaction.businessId,
        description: this.transaction.description,
        thirdPartyId: this.transaction.target == 'ThirdParty' ? this.transaction.thirdPartyId : null
      }          

      if(this.transaction.invoiceMode == 'invoice'){        
        data.paymentMethodId = this.transaction.paymentMethodId;        
        data.billingCompanyBankAccountId = this.transaction.billingCompanyBankAccountId;                
        data.paymentDuedate = this.transaction.paymentDuedate.toISOString();
      }

      if(this.transaction.target == 'Client'){
        data.invoiceRetentionPercent = null;
        data.invoiceRetentionDays = null;
       // data.transactionSerieId = null;
      }
      
      let result:any = await firstValueFrom(this.transactionsService.invoicePendingJobs(data));      
            
      if(result.success){
        if(this.transaction.invoiceMode == 'outgoing_delivery'){
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Albarán generado correctamente' });
        }
        if(this.transaction.invoiceMode == 'invoice'){
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Factura generada correctamente' });
        }

        //el envío a la compañía va aparte para que un fallo suyo no se confunda con un fallo al facturar:
        //la factura ya está creada y se puede reintentar el envío desde su ficha.
        if(this.sendToCompany && this.canSendToCompany && result.data){
          try{
            await firstValueFrom(this.transactionsService.sendToCompany(result.data));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Solicitud de envío a la compañía registrada correctamente' });
          }catch{
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'La factura se ha creado pero no se ha podido registrar el envío a la compañía' });
          }
        }

        this.loadData();

        //si no estaba cerrado el expediente, proponemos cerrarlo
        if(this.case && !this.case.caseState.isFinal){
          this.closeProposal();
        }
      }else{
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al facturar los trabajos seleccionados' });
      }
      
    }    
  }

  cancel() {
    this.dynamicDialogRef.close(false);
  }

  closeProposal() {
    this.confirmationService.confirm({
      message: "El expediente no esta cerrado, ¿quiere cerrarlo ahora?",
      header: "Cerrar expediente",
      acceptLabel: "Sí",
      rejectLabel: "No",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let ref = this.dialogService.open(CaseStateChangeComponent, {
          closable: true,
          modal: true,
          header: 'Cerrar expediente',
          width: '500px',
          data: {
            id: this.case?.id,
            isFinal: true
          }
        });
        this.confirmationService.close();
        ref.onClose.subscribe((data: any) => {
          this.loadCase();
        });
      },
      reject: (error: any) => {
        this.confirmationService.close();
        this.loadCase();
      }
    });
  }
  

  getSubtotalSelected(): number {    
    return this.selectedLines.reduce((sum, job) => sum + (job.total - job.taxAmount), 0); //para tener en cuenta el incremento de la guardia et.
  }
  
  getAmountSelected(): number {
    //Calculamos el iva de la suma del subtotal + los descuentos y retenciones con el % de iva del primer trabajo seleccionado
    let tax = this.selectedLines[0]?.taxPercent ?? 0;    
    return this.selectedLines.reduce((sum, job) => sum + (job.taxAmount), 0);
    //return (this.getSubtotalSelected() - this.getDiscountAmount() - (this.transaction.target == 'Company'?this.getRetentionAmount():0)) * tax / 100;
  }
  
  getDiscountAmount(): number {
    const subtotal = this.getSubtotalSelected();
    return (this.transaction.invoiceDiscount ?? 0) / 100 * subtotal;
  }

  getRetentionAmount(): number {
    const subtotal = this.getSubtotalSelected();
    return (this.transaction.invoiceRetentionPercent ?? 0) / 100 * subtotal;
  }
  
  getTotalSelected(): number {
    const subtotal = this.getSubtotalSelected();
    const discount = this.getDiscountAmount();
    const retention = this.getRetentionAmount();
    const taxes = this.getAmountSelected();
    
    return subtotal - discount - (this.transaction.target == 'Company'?retention:0) + taxes;
  }

  getAdvancedAmountSelected(): number {
    return this.selectedLines
    .filter(job => job.chargedByWorker)
    .reduce((sum, job) => sum + job.total, 0);
    
  }


  async loadPaymentsMethods() {

    let response = await firstValueFrom(this.paymentsMethodsService.all({}));
    this.paymentsMethods = response.data;    
  }

  onPaymentMethodChange(paymentMethodId: string): void {    
    const selectedMethod = this.paymentsMethods.find(m => m.id === paymentMethodId);    
    this.selectedPaymentMethodRequiresBank = selectedMethod?.businessBankAccountEnabled === true;    
  }

  async loadBillingCompaniesBankAccounts() {

    let filters: any = {};
    if (this.transaction != null && this.transaction.businessId != null) {
      filters.businessId = new Filter(FilterOperation.equals, 'businessId', "", this.transaction.businessId);
    }
    
    let params: IParamsCollection = {
      page: { size: 0 },
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.businessBankAccountsService.all(params));
    this.billingCompaniesBanksAccounts = response.data;
  }


  async loadTransactionSeries() {
    //Obtenemos el id del tipo de transacición factura de empresa
    let paramsTransactionType: IParamsCollection = {
      include: []
    }
    //creamos filtros
    const codeValue = (this.transaction.target === "Client" || this.transaction.target === "ThirdParty")
    ? "outgoing_invoice"
    : (this.transaction.invoiceMode === "invoice"
        ? "company_outgoing_invoice"
        : "company_outgoing_delivery_note");
    paramsTransactionType.filter = FilterBuilder.fromObject({ code: new Filter(FilterOperation.equals, 'code', '', codeValue) }).build();

    let responseTransactionType = await firstValueFrom(this.transactionsTypesService.all(paramsTransactionType));
    this.transactionTypeInvoice = responseTransactionType.data[0];    

    let filters: any = {};
    
   // if(this.transaction.target == "Company"){
      filters.contractId = new Filter(FilterOperation.equals, 'contractId', "", this.case?.contractId);      
      filters.transactionTypeId = new Filter(FilterOperation.equals, 'transactionSerie.transactionTypeId', "", this.transactionTypeInvoice.id);
    //}
    /*else{

      filters.transactionTypeId = new Filter(FilterOperation.equals, 'transactionTypeId', "", transactionTypeInvoice.id);
    }*/

    

    let params: IParamsCollection = {
      page: { size: 0 },      
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response;

     params.include = ['transactionSerie'];
      response = await firstValueFrom(this.contractTransactionSeriesService.all(params));
      this.transactionSeries = response.data.map((m: any) => {
        return m.transactionSerie;
      });
      
      if(this.transactionSeries.length == 0){
        this.transactionSeries = [
          {
            id: 'default',
            name: 'Serie por defecto'
          }
        ];
      }

    /*
    if(this.transaction.target == "Client"){            
      this.transactionSeries = [
        {
          id: 'default',
          name: 'Serie por defecto'
        }
      ];      
    }else{
      params.include = ['transactionSerie'];
      response = await firstValueFrom(this.contractTransactionSeriesService.all(params));
      this.transactionSeries = response.data.map((m: any) => {
        return m.transactionSerie;
      });
      
      if(this.transactionSeries.length == 0){
        this.transactionSeries = [
          {
            id: 'default',
            name: 'Serie por defecto'
          }
        ];
      }
    }     */       
    
    //TODO: marcamos la seria que tenga para el tipo de transaccion
    //marcamos la primera
    this.transaction.transactionSerieId = this.transactionSeries[0]?.id;
    
  }

  async targetSelected() {
    this.transaction.invoiceMode = null;
    this.transaction.transactionSerieId = null;

    const selectedTarget = this.targets.find(t => t.id === this.transaction.target);

    //Filtramos la lista de trabajos por target


    if (selectedTarget?.id === 'Client') {      
      this.jobs = this.totalJobs.filter((m:any) => m.target === 'Client');
      this.selectedLines = [...this.jobs];
      this.filteredInvoiceModes = this.invoiceModes.filter(m => m.id === 'invoice');
      this.transaction.invoiceMode = 'invoice';      
      
    } else if (selectedTarget?.id === 'ThirdParty') {      
      this.jobs = this.totalJobs.filter((m:any) => m.target === 'ThirdParty');
      this.selectedLines = [...this.jobs];
      this.filteredInvoiceModes = this.invoiceModes.filter(m => m.id === 'invoice');
      this.transaction.invoiceMode = 'invoice';
      this.loadAffecteds();   
      
    } else {      
      this.jobs = this.totalJobs.filter((m:any) => m.target === 'Company');
      this.selectedLines = [...this.jobs];
      this.filteredInvoiceModes = [...this.invoiceModes];
      this.transaction.invoiceMode = 'outgoing_delivery';      
      
      //marcamos la que tenga marcada el contrato solo si es a COMPAÑIA
      if(this.case?.contract.invoiceMode) {
        this.transaction.invoiceMode = this.case?.contract.invoiceMode;
      }
    }
    
    if(this.filteredInvoiceModes.length == 1){
      this.transaction.invoiceMode = this.filteredInvoiceModes[0].id;
    }
    
    if (!this.filteredInvoiceModes.some(m => m.id === this.transaction.invoiceMode)) {
      this.transaction.invoiceMode = null;
    }        
  
    

    this.loadTransactionSeries();

  }

  async loadAffecteds() {
    
    //cargamos los afectados
    let filter : any = {
      caseId: new Filter(FilterOperation.equals, "caseId", '', this.config.data.caseId)
    };
    let params:IParamsCollection = {
      page: { size: 50 },
      sort: ['name'],
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.affectedsService.all(params));
    this.affecteds = response.data;
  }

}
